// SPRS score gauge: semicircle, range -203 to +110.
export default function SprsGauge({ score }) {
  const min = -203, max = 110;
  const has = score !== null && score !== undefined;
  const clamped = has ? Math.max(min, Math.min(max, score)) : min;
  const frac = (clamped - min) / (max - min); // 0..1
  const angle = -90 + frac * 180; // -90 (left) .. +90 (right)

  const gaugeColor = (available, fraction) => {
    if (!available) return "#94A3B8";
    if (fraction > 0.75) return "#16A34A";
    if (fraction > 0.45) return "#D97706";
    return "#DC2626";
  };
  const color = gaugeColor(has, frac);

  const cx = 130, cy = 130, r = 100;
  const polar = (deg) => {
    const rad = (deg - 90) * (Math.PI / 180);
    return [cx + r * Math.cos(rad), cy + r * Math.sin(rad)];
  };
  const arc = (startDeg, endDeg) => {
    const [x1, y1] = polar(startDeg);
    const [x2, y2] = polar(endDeg);
    const large = endDeg - startDeg > 180 ? 1 : 0;
    return `M ${x1} ${y1} A ${r} ${r} 0 ${large} 1 ${x2} ${y2}`;
  };

  return (
    <div className="flex flex-col items-center" data-testid="sprs-gauge">
      <svg viewBox="0 0 260 150" className="w-full max-w-[260px]">
        <path d={arc(-90, 90)} fill="none" stroke="#E2E8F0" strokeWidth="16" strokeLinecap="round" />
        {has && (
          <path d={arc(-90, angle)} fill="none" stroke={color} strokeWidth="16" strokeLinecap="round" />
        )}
        <text x={cx} y={108} textAnchor="middle" className="font-display" style={{ fontSize: 40, fontWeight: 900, fill: color }}>
          {has ? score : "—"}
        </text>
        <text x={cx} y={132} textAnchor="middle" style={{ fontSize: 11, fill: "#64748B", letterSpacing: 2 }}>
          SPRS SCORE
        </text>
      </svg>
      <div className="flex justify-between w-full max-w-[260px] text-[10px] font-mono text-slate-400 -mt-1 px-2">
        <span>-203</span><span>+110</span>
      </div>
    </div>
  );
}
